<template>
  <section :class="$style.balance">
    <slot name="balance" />
    <p :class="balanceClass">
      {{ balanceString }}<span :class="$style.balance__month">/月</span>
    </p>
  </section>
</template>

<script setup lang="ts">
import { computed, useCssModule } from 'vue'
import { toYenStringWithFirstDecimal } from '../yenScale'

const props = defineProps<{
  row: {
    monthlyBalance: number
  }
}>()

const balanceString = toYenStringWithFirstDecimal(props.row.monthlyBalance)

const style = useCssModule()
const balanceClass = computed(() => [
  style.balance,
  {
    [style['balance--lessThanZero']]: props.row.monthlyBalance < 0,
  },
])
</script>

<style lang="scss" module>
.balance {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;

  &--lessThanZero {
    color: $color-caution-accent;
  }

  &__month {
    font-size: 10px;
  }
}
</style>
